// Native & external imports
import { Pipe, PipeTransform, inject } from "@angular/core";
import * as moment from "moment";
// Services
import { AppLocalization, LocalizedDateTimeFormat } from '@icamppro-customer-portal/shared/cmp-base';

@Pipe({ name: "localedate", standalone: false })
export class LocaleDatePipe implements PipeTransform {
  private _appLocalization = inject(AppLocalization);

  transform(
    value: Date | number | string | moment.Moment,
    format: LocalizedDateTimeFormat,
    noTZChange?: boolean,
    valueIsUTC?: boolean,
  ): string {
    return this._appLocalization.client.formatDateTime(value, format, {
      convertToLocalTZ: !noTZChange,
      forceDateIsUTC: !!valueIsUTC,
    });
  }
}
